import { FC } from "react";
import styled from "styled-components";
import { getLinkFromContentType, ink, localiseContentType } from "@utils";
import Link from "next/link";
import { MobileOnly } from "components/templates/Breakpoints";
import { useBreakpoints, YuLifeLocale } from "@hooks";
import { StaticRoutes } from "@routes";
import { NotMobile } from "@yu-life/yulife-components-static";
import { LocationInfo, PageType } from "./types";

interface ResourcesBreadcrumbProps {
  locationInfo?: LocationInfo;
  pageType: PageType;
  contentHomePage?: boolean;
  contentCategoryPage?: boolean;
  locale: YuLifeLocale;
}

const ResourcesBreadcrumb: FC<ResourcesBreadcrumbProps> = ({ locationInfo, pageType, locale }) => {
  const { contentType, categoryName, slug } = locationInfo;
  const { isMobile } = useBreakpoints();

  const resourcesLink = locale !== "jp" ? StaticRoutes.resourceHub : null;

  const arrow = ">";
  const reversedArrow = "<";

  if (pageType == "content") {
    return (
      <Container>
        {resourcesLink ? (
          <Breadcrumb href={resourcesLink}>{isMobile && `${reversedArrow} `}Resources</Breadcrumb>
        ) : (
          <Breadcrumb as="span" href={resourcesLink}>
            {isMobile && `${reversedArrow} `}Resources
          </Breadcrumb>
        )}
        <NotMobile>
          <Breadcrumb href={getLinkFromContentType(contentType)}>
            {arrow} <strong>{localiseContentType(contentType, locale)}</strong>
          </Breadcrumb>
        </NotMobile>
      </Container>
    );
  }

  if (pageType == "category") {
    return (
      <Container>
        <NotMobile>
          {resourcesLink ? (
            <Breadcrumb href={resourcesLink}>Resources </Breadcrumb>
          ) : (
            <Breadcrumb as="span" href={resourcesLink}>
              Resources{" "}
            </Breadcrumb>
          )}
          <Breadcrumb href={getLinkFromContentType(contentType)}>
            {arrow} {localiseContentType(contentType, locale)}{" "}
          </Breadcrumb>
          <Breadcrumb href={getLinkFromContentType(contentType, undefined, slug)}>
            {arrow} <strong>{categoryName}</strong>
          </Breadcrumb>
        </NotMobile>
        <MobileOnly>
          <Breadcrumb href={getLinkFromContentType(contentType)}>
            {isMobile ? reversedArrow : arrow} {localiseContentType(contentType, locale)}
          </Breadcrumb>
        </MobileOnly>
      </Container>
    );
  }
  return (
    <Container>
      <NotMobile>
        {resourcesLink ? (
          <Breadcrumb href={resourcesLink}>Resources </Breadcrumb>
        ) : (
          <Breadcrumb as="span" href={resourcesLink}>
            Resources{" "}
          </Breadcrumb>
        )}
        <Breadcrumb href={getLinkFromContentType(contentType)}>
          {arrow} {localiseContentType(contentType, locale)}
        </Breadcrumb>
      </NotMobile>
      <Breadcrumb href={getLinkFromContentType(contentType, undefined, slug)}>
        {isMobile ? "<" : arrow} <strong>{categoryName}</strong>
      </Breadcrumb>
    </Container>
  );
};

export default ResourcesBreadcrumb;

const Container = styled.div`
  display: flex;
  gap: 0.35rem;
`;

const Breadcrumb = styled(Link)`
  color: ${ink.inkSubtle};
  font-size: 1rem;
  letter-spacing: 0.075rem;
`;
